import styled, { css } from "styled-components";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import TextAtm from "../TextAtm";
export var ToggleWrapper = styled.div.withConfig({
  componentId: "sc-pdqs8w-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["width:fit-content;padding:", ";border-radius:", ";background-color:", ";box-shadow:", ";"], unit(4), getBorderRadius(theme, "mlarge"), getColor(theme, "backgroundLight"), getBoxShadow(theme, "tiny"));
});
export var Toggle = styled.div.withConfig({
  componentId: "sc-pdqs8w-1"
})(function (_ref2) {
  var $hasActive = _ref2.$hasActive,
    $hasFirstElementActive = _ref2.$hasFirstElementActive,
    theme = _ref2.theme;
  return css(["display:inline-grid;position:relative;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;border:", " solid ", ";border-radius:", ";background-color:", ";box-shadow:0 ", " ", " 0 rgba(0,0,0,0.14) inset;cursor:pointer;", ""], unit(1), getColor(theme, "background"), getBorderRadius(theme, "huge"), getColor(theme, "backgroundLightToDefault"), unit(1), unit(4), $hasActive ? css(["&:after{position:absolute;left:0;top:0;transform:", ";content:\"\";width:50%;height:100%;border:", " solid ", ";background-color:", ";border-radius:", ";transition:transform 0.2s;}"], $hasFirstElementActive ? 0 : "translateX(calc(100%))", unit(1), getColor(theme, "backgroundDarkerToDark"), getColor(theme, "backgroundLightToDefault"), getBorderRadius(theme, "huge")) : null);
});
export var Label = styled(TextAtm).withConfig({
  componentId: "sc-pdqs8w-2"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["z-index:1;padding:", " ", ";transition:color 0.2s;border:", " solid transparent;text-align:center;user-select:none;&:hover{color:", ";}"], space(0.5), space(2), unit(1), getColor(theme, "backgroundBlack", "hover"));
});